import React, { useState, useEffect } from "react"
import "./Navbar.css"
import { useTranslation } from "react-i18next";
import langlang from '../../images/world.png'
import notify from '../../images/not.png'
import useClickOutside from '../../useClickOutside'
import SendNotification from "./SendNotification";

const Navbar = ({ openSidebar }) => {
    let langLocal = localStorage.getItem('absherLang');
    const [t, i18n] = useTranslation();
    const [open, setOpen] = useState(false)
    const [langPop, setlangPop] = useState(false);
    let domNode = useClickOutside(() => {
        setlangPop(false);
    });
    useEffect(() => {
        i18n.changeLanguage(localStorage.getItem('absherLang'));
    }, []);
    return (
        <>
            <nav className="navbar" dir={langLocal == "ar" ? "rtl" : "ltr"}>
                <div className="nav_icon" onClick={() => openSidebar()}>
                    <i className="fa fa-bars"></i>
                </div>
                <div className="navbar_left">
                    <input className="navbar_left_input" type="text" placeholder="Search .." />
                </div>
                <div className="navbar_right">
                    <img src={notify} onClick={() => setOpen(true)} />
                    <img src={langlang} onClick={() => setlangPop(true)} />
                    {langPop && (
                        <div className={langLocal == "ar" ? "lang langL" : "lang langR"} ref={domNode} >
                            <span
                                className={langLocal == "ar" ? "textAlignRight" : ""}
                                onClick={() => {
                                    i18n.changeLanguage("en");
                                    console.log(i18n.language)
                                    localStorage.setItem('absherLang', i18n.language);
                                }}
                            >
                                {t('english')}
                            </span>
                            <span
                                className={langLocal == "ar" ? "textAlignRight" : ""}
                                onClick={() => {
                                    i18n.changeLanguage("ar");
                                    console.log(i18n.language)
                                    localStorage.setItem('absherLang', i18n.language);
                                }}
                            >
                                {t('arabic')}
                            </span>
                        </div>
                    )}
                </div>
            </nav>
            {
                open == true ? (
                    <SendNotification open={open} setOpen={setOpen} />
                ) : <></>
            }
        </>
    )
}

export default Navbar;